import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001'
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('relea_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  async err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('relea_token');
      localStorage.removeItem('relea_nombre');
      localStorage.removeItem('relea_rol');
      window.location.reload();
      return Promise.reject(err);
    }
    // Retry on Network Error (Railway cold start): up to 3 tries, backoff 3s / 6s / 9s
    const cfg = err.config;
    if (!err.response && cfg && !cfg._skipRetry) {
      cfg._retries = (cfg._retries || 0) + 1;
      if (cfg._retries <= 3) {
        await new Promise(r => setTimeout(r, 3000 * cfg._retries));
        return api.request(cfg);
      }
    }
    return Promise.reject(err);
  }
);

export default api;